(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yugal-article"]) return;
  try {
    
  document.querySelectorAll('[data-article-body]').forEach((body) => {
    const nav = body.closest('.y-article').querySelector('[data-toc]');
    const list = nav?.querySelector('[data-toc-list]');
    const heads = [...body.querySelectorAll('h2')];
    if (!list || heads.length < 3) return;
    heads.forEach((h, i) => {
      if (!h.id) h.id = 'part-' + (i + 1);
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      li.append(a);
      list.append(li);
    });
    nav.hidden = false;
  });

  } catch(e) { console.error(e); }
})();
})();
